export const CONFIGURABLE_PROPS = {
  'form': 'form',
  'page': 'page',
  'step': 'step',
  'header': 'header',
  'footer': 'footer',
  'lang': 'language',
  'sum': 'donation.sum',
  'version': 'donation.version',
  'source': 'donation.source',
  'pageSource': 'donation.page_source'
}

export const EXTRA_RATE = 10

export const LABELS = {
  ru: {
    title: 'Помочь проекту',
    subtitle: '',
    otherSum: 'Другая сумма',
    email: 'Ваш email',
    emailSuggestion: 'Может быть, вы имели ввиду',
    unsubscribeTip: link => `Вы в любой момент сможете отписаться, указав свой email <a href="${link}" target="_blank">на этой странице</a>`,
    unsubscribeTipNoLink: 'Вы в любой момент сможете отписаться, указав свой email',
    name: 'Ваше имя (необязательно)',
    monthOn: 'Ежемесячно',
    monthOff: 'Единоразово',
    insideCountry: 'Карты РФ',
    outsideCountry: 'Карты не РФ',
    translate: 'English version',
    donate: 'Помочь проекту',
    subscribe: 'Оформить подписку',
    waitMessage: 'Пожалуйста, подождите...',
    successTitle: 'Спасибо!',
    successMsg: 'Ваше пожертвование прошло успешно! Мы будем очень благодарны, если вы расскажете своим друзьям о нашем проекте!',
    errorTitle: 'Ой :(',
    errorMsg: 'К сожалению произошла ошибка',
    resetForm: 'Вернуться назад',
    showMainForm: 'Пожертвовать банковской картой',
    confirm: link => `Принимаю условия <a href="${link}" target="_blank">договора оферты</a>`,
    confirmDataPolicy: (links) => `Соглашаюсь с <a href="${links[0]}" target="_blank">офертой</a> и <a href="${links[1]}" target="_blank">политикой обработки данных</a>`,
    bankButton: '<div class="title">Банковские реквизиты</div><small class="description">Как перевести деньги напрямую через банк</small>',
    donateOnlineButton: '<div class="title">Онлайн пожертвование</div><small class="description">С помощью банковских карт и других методов</small>',
    reportsButton: '<div class="title">Отчеты</div><small class="description">Что нам удалось сделать с вашей помощью?</small>',
    bankDetails: 'Индивидуальный предприниматель Бейлинсон Даниил Александрович<br><strong>ОГРНИП: </strong>320774600356937<br><strong>ИНН: </strong>772572798271<br><strong>Расчетный счет: </strong>40802810301500108880<br><strong>Название Банка: </strong>ООО «Банк Точка»<br><strong>Кор.счет: </strong>30101810745374525104<br><strong>БИК банка: </strong>044525104<br><strong>Назначение платежа: </strong>дарение<br /><br />Мы можем принимать переводы только от физических лиц. Если вы хотели бы поддержать нас как юридическое лицо, напишите нам, пожалуйста, на <a href="mailto:donate@ovdinfo.org">donate@ovdinfo.org</a>.',
    subscribtionTitle: 'Человек не должен оставаться один на один с системой',
    subscribtionMsg: 'Каждый день люди в нашей стране сталкиваются с несправедливостью со стороны властей. Им очень нужна ваша поддержка, ведь без вас мы не сможем принимать звонки и помогать им в судах. Если каждый, кто читает это, оформит подписку на ежемесячное пожертвование, больше людей получат помощь.<br><br>Спасибо!',
    unsubscribe: 'Отписаться',
    unsubscribeEmailText: 'Пожалуйста, укажите e-mail, на который была зарегистрирована подписка на регулярные пожертвования. На этот адрес будет выслана ссылка, пройдя по которой вы сможете подтвердить отписку от пожертвований.',
    unsubscribeFeedbackPlaceholder: 'Ваш отзыв',
    unsubscribeFeedbackText: 'Мы будем очень признательны, если на прощание вы напишите свой отзыв о программе регулярных пожертвований или даже расскажете, почему вы решили отказаться от участия в ней.',
    unsubscribeError: 'Кажется, у вас нет подписок на пожертвования :( Попробуйте ввести другую почту или пришлите нам сумму и точную дату и сумму одного из списаний на <a href="mailto:donate@ovdinfo.org">donate@ovdinfo.org</a> – мы отменим подписку вручную.',
    unsubscribeConfirmation: email => `Мы отправили письмо на электронный адрес ${email}. Для завершения процедуры отписки, пожалуйста, пройдите по указанной в письме ссылке.`,
    unsubscribeSuccess: 'Вы отписались от программы регулярных пожертвований в пользу проекта «ОВД-Инфо». Спасибо, что были с нами!<br>Мы ценим любую поддержку от наших доноров. Ваши пожертвования позволяют нам продолжать нашу работу. Никто не должен оставаться один на один с системой.',
    changeSubscription: 'Изменить сумму',
    changeSubscriptionEmailText: 'Пожалуйста, укажите e-mail, на который зарегистрирована подписка на регулярные пожертвования. На этот адрес будет выслана ссылка, пройдя по которой вы сможете подтвердить смену суммы ежемесячного пожертвования. Ниже укажите текущую сумму списания и новую сумму пожертвования.',
    changeSubscriptionOldSumPlaceholder: 'Текущая сумма',
    changeSubscriptionSumPlaceholder: 'Новая сумма',
    changeSubscriptionError: 'К сожалению что-то пошло не так. На указанный адрес не оформлены регулярные пожертвования с указанной суммой. Пожалуйста, проверьте правильно ли указан адрес и текущая сумма пожертвования?',
    changeSubscriptionConfirmation: email => `Мы отправили письмо на электронный адрес ${email}. Для завершения процедуры изменения суммы ежемесячного пожертвования, пожалуйста, пройдите по указанной в письме ссылке.`,
    changeSubscriptionSuccess: 'Вы успешно сменили сумму пожертвования!',
    'pp-gg-description': 'Мы принимаем пожертвования через PayPal и карты зарубежных банков на портале GlobalGiving',
    'pp-gg-label': 'Перейти на GlobalGiving',
    'card-notes': 'Оплата возможна только с помощью карт, выпущенных в РФ',
    'apple-pay': 'Оплата через Apple Pay доступна в браузере Safari на macOS и iOS',
    'btc-eth-description': 'Мы принимаем разовые пожертвования в 8 видах криптовалюты',
    'btc-eth-label': 'Поддержать криптой',
    'zaodno-description': 'Помочь задержанным оплатить защитников напрямую можно на платформе «Заодно»',
    'zaodno-label': 'Помочь задержанным',
    'otherMethodsTitle': 'Другие способы поддерживать нас:',
    'otherMethodsZaodnoLabel': 'Переводом с карты на карту',
    'otherMethodsZaodnoDescription': 'Платформа «Заодно» позволяет поддержать напрямую наших подзащитных: все эти люди обратились за помощью к нам или к другим проектам. В случае с ОВД-Инфо мы уже нашли для них защитников, а вы можете помочь оплатить их работу прямым переводом на карту, минуя ОВД-Инфо, и ввод данных карты.',
    'otherMethodsZaodnoButton': 'Заодно',
    'otherMethodsInternationalCardsLabel': 'С карт иностранных банков',
    'otherMethodsInternationalCardsDescription': 'Мы принимаем регулярные и разовые пожертвования с карт иностранных банков. Чтобы оформить такое пожертвование, просто выберите "Карты не РФ" в форме на сайте.',
    'otherMethodsInternationalCardsButton': 'Поддержать',
    'otherMethodsCryptoLabel': 'Криптой',
    'otherMethodsCryptoDescription': 'Все пожертвования, сделанные в криптовалюте, мы будем хранить до лучших (или худших) времен.',
    'otherMethodsCryptoButton': 'Помочь криптой',
    'currency-RUB': 'Рубли',
    'currency-EUR': 'Евро',
    'currency-USD': 'Доллары',
    'mode-annually': 'Ежегодно',
    'mode-monthly': 'Ежемесячно',
    'mode-one-off': 'Единоразово',
    extraRate: percentage => `Добавить ${percentage}% на комиссию`
  },
  en: {
    title: 'Help us stop political persecution',
    subtitle: 'In today’s Russia anyone can face political persecution. Your donation helps us protect them.',
    otherSum: 'other',
    sumHelp: '100 rubles roughly equals €1.3 or $1.5, <a target="_blank" href="https://www.xe.com/currency/rub-russian-ruble">current exchange rate</a>',
    email: 'Your email',
    emailSuggestion: 'Did you mean',
    unsubscribeTip: link => `You will be able to unsubscribe with your email at any moment <a href="${link}" target="_blank">on this page</a>`,
    unsubscribeTipNoLink: 'You will be able to unsubscribe with your email at any moment',
    name: 'Your name (optionally)',
    monthOn: 'Monthly',
    monthOff: 'One Time',
    translate: 'Русская версия',
    donate: 'Donate',
    subscribe: 'Make a monthly donation',
    waitMessage: 'Please wait...',
    successTitle: 'No one should be left alone with the system!',
    successRegularSubtitle: 'You\'ve signed up for monthly donations thank you!',
    successOneSubtitle: 'We\'ve received your donation. Thank you!',
    successMsg: 'You\'ve succefully made a donation! We will be very grateful if you tell your friends about our project!',
    errorTitle: 'Sorry :(',
    errorMsg: 'Something goes wrong',
    resetForm: 'Go back',
    showMainForm: 'Donate via Bank Card',
    confirm: (links) => `I have read and consent to OVD-Info <a href="${links[0]}">Terms</a> and <a href="${links[1]}" target="_blank">Privacy Policy</a>.`,
    confirmDataPolicy: (links) => `I have read and consent to OVD-Info <a href="${links[0]}">Terms</a> and <a href="${links[1]}" target="_blank">Privacy Policy</a>.`,
    bankButton: '<div class="title">Bank details</div><small class="description">How to transfer donation through the bank</small>',
    donateOnlineButton: '<div class="title">Donate now</div><small class="description">Via bank card or other payment method</small>',
    reportsButton: '<div class="title">Our reports</div><small class="description">What we did with your support</small>',
    bankDetails: '<strong>For transfer in euro</strong><br><strong>Beneficiary Bank</strong><br><em>SWIFT code SABRRUMM</em><br/><em>SBERBANK (HEAD OFFICE – ALL BRANCHES AND OFFICES IN RUSSIA) MOSCOW, RUSSIA</em><br/><em>Russian Federation, Moscow, Preobrazhenskaya square 7/a, Building 1</em><br/><strong>Beneficiary Customer</strong><br><em>40703978738290201094</em><br/><em>MEMORIAL HUMAN RIGHTS CENTER</em><br/><em>MALYI KARETNYI PEREULOK 12, MOSCOW 127051, RUSSIA</em><br/><strong>Details of Payment</strong><br><em>Private target donation for the authorized activities of the organisation</em><br/><strong>Correspondent Bank</strong><br><em>SWIFT code DEUTDEFF</em><br/><em>DEUTSCHE BANK AG. FRANKFURT AM MAIN, GERMANY</em>',
    subscribtionTitle: 'Человек не должен оставаться один на один с системой',
    subscribtionMsg: 'Каждый день люди в нашей стране сталкиваются с несправедливостью со стороны властей. Им очень нужна ваша поддержка, ведь без вас мы не сможем принимать звонки и помогать им в судах. Если каждый, кто читает это, оформит подписку на ежемесячное пожертвование, больше людей получат помощь.<br><br>Спасибо!',
    unsubscribe: 'Unsubscribe',
    unsubscribeEmailText: 'Please enter the e-mail which you used in order to subscribe for regular donations. A link will be sent to this address, which you can follow to confirm unsubscription from donations.',
    unsubscribeFeedbackPlaceholder: 'Your feedback',
    unsubscribeFeedbackText: 'We would be very grateful if you will leave a feedback on the regular giving programme or even tell us why you decided not to participate in it.',
    unsubscribeError: 'Something goes wrong. If you can\'t unsubscribe from montly donations, please write to us <a href="mailto:donate@ovdinfo.org">donate@ovdinfo.org</a>.',
    unsubscribeConfirmation: email => `We sent an email to ${email}. To complete unsubscribe please follow a link from email.`,
    unsubscribeSuccess: 'You just unsubscribed from montly donations for OVD-Info project. Thank you for being with us! <br />We appreciate all support from our donors. Your donations allow us to continue our work. No one should be left alone with the system.',
    changeSubscription: 'Change donation',
    changeSubscriptionEmailText: 'Please enter the e-mail which you used in order to subscribe for regular donations. A link will be sent to this address, which you can follow to confirm the change of the amount of donation.',
    changeSubscriptionOldSumPlaceholder: 'Current sum',
    changeSubscriptionSumPlaceholder: 'New sum',
    changeSubscriptionError: 'Unfortunately, something went wrong. No regular donations with the specified amount have been processed to the specified email. Please check if the email and the current donation amount are correct.',
    changeSubscriptionConfirmation: email => `We have sent an email to ${email}. To confirm a change in your monthly donation amount, please follow the link provided in the email.\n If the email did not arrive, please email donate@ovdinfo.org. There may be a mistake in the email or you may have donated to a different address.`,
    changeSubscriptionSuccess: 'You have successfully changed your donation amount!',
    'pp-gg-description': 'We accept donations via PayPal on GlobalGiving',
    'pp-gg-label': 'Open GlobalGiving Page',
    'apple-pay': 'Apple Pay is available in Safari on all iOS & macOS devices',
    'btc-eth-description': 'We accept donations in 8 cryptocurrencies',
    'btc-eth-label': 'Donate in Crypto',
    'zaodno-description': 'You can help detainees pay for the work of legal defense lawyers on the platform "Zaodno"',
    'zaodno-label': 'Help the detainees',
    'otherMethodsTitle': 'Other ways to support us:',
    'otherMethodsZaodnoLabel': 'By card-to-card transfer',
    'otherMethodsZaodnoDescription': 'The platform "Zaodno" allows us to support our defendants directly: all of these people have asked us or other projects to help. In the case of OVD-Info, we have already found legal defenders for them, and you can help pay for their work by direct card transfer, bypassing OVD-Info and entering card details.',
    'otherMethodsZaodnoButton': 'Zaodno',
    'otherMethodsInternationalCardsLabel': 'With foreign cards',
    'otherMethodsInternationalCardsDescription': 'We accept regular and one-time donations from foreign bank cards.',
    'otherMethodsInternationalCardsButton': 'Support',
    'otherMethodsCryptoLabel': 'By Crypto',
    'otherMethodsCryptoDescription': 'We will keep all donations made in cryptocurrency until better (or worse) time.',
    'otherMethodsCryptoButton': 'Help with Crypto',
    'currency-RUB': 'Rubles',
    'currency-EUR': 'Euros',
    'currency-USD': 'Dollars',
    'mode-annually': 'Annually',
    'mode-monthly': 'Monthly',
    'mode-one-off': 'One-time',
    extraRate: percentage => `Add ${percentage}% to pay the comissions`
  }
}

export const VALIDATION_MESSAGES = {
  ru: {
    custom: {
      agreement: {
        required: 'К сожалению, мы не можем принять пожертвование без согласия с договором'
      },
      sum: {
        required: 'Сумма пожертвования должна быть больше одного рубля',
        min_value: 'Сумма пожертвования должна быть больше 0'
      },
      email: {
        required: 'Пожалуйста, оставьте свой email',
        email: 'Пожалуйста, введите корректный email'
      }
    }
  },
  en: {
    custom: {
      agreement: {
        required: 'We can\'t accept your donation if you are not agree to our Terms and Conditions'
      },
      sum: {
        required: 'Please fill amount which you would like to donate',
        min_value: 'Please fill amount which you would like to donate'
      },
      email: {
        required: 'Please fill email',
        email: 'Please type a correct email'
      }
    }
  }
}
